/* FZ - Start - Caricamento foto clienti sul VPS (upload_foto) */
/* bu-foto-upload — carica la foto del cliente sul nostro server appena la sceglie,
   e mette nel modulo «Aggiungi al carrello» una proprietà della riga:
     Foto: F-1014-7K3QX (IMG_1234.HEIC)
   Il codice è il nome del file sul server: dall'ordine si risale alla foto.
   Come funziona e perché: conoscenza/upload-foto.md */
(function () {
  if (customElements.get('bu-foto-upload')) return;

  var MAX_BYTE = 25 * 1024 * 1024;
  var ESTENSIONI = ['jpg', 'jpeg', 'png', 'heic', 'heif', 'webp'];
  var NOME_PROPRIETA = 'properties[Foto]';

  var TESTI = {
    it: {
      scegli: 'Scegli la foto',
      cambia: 'Cambia foto',
      riprova: 'Riprova',
      carica: 'Sto caricando la foto…',
      fatto: 'Foto caricata: ',
      troppo: 'La foto supera 25 MB. Scegline una più leggera, oppure mandacela dopo rispondendo alla mail di conferma dell’ordine.',
      tipo: 'Questo file non sembra una foto. Vanno bene JPG, PNG, HEIC e WEBP.',
      tanti: 'Troppi caricamenti in poco tempo. Riprova fra qualche minuto.',
      rete: 'Non riesco a caricare la foto adesso. Riprova, oppure mandacela dopo rispondendo alla mail di conferma dell’ordine.',
      aspetta: 'Aspetta un attimo: la foto sta finendo di caricarsi.',
      manca: 'Per questo prodotto serve la foto: caricala qui sopra.'
    },
    de: {
      scegli: 'Foto auswählen',
      cambia: 'Foto ändern',
      riprova: 'Erneut versuchen',
      carica: 'Das Foto wird hochgeladen…',
      fatto: 'Foto hochgeladen: ',
      troppo: 'Das Foto ist größer als 25 MB. Wähle ein kleineres oder schick es uns später als Antwort auf die Bestellbestätigung.',
      tipo: 'Diese Datei scheint kein Foto zu sein. Möglich sind JPG, PNG, HEIC und WEBP.',
      tanti: 'Zu viele Uploads in kurzer Zeit. Bitte versuche es in ein paar Minuten erneut.',
      rete: 'Das Foto kann gerade nicht hochgeladen werden. Versuche es erneut oder schick es uns später als Antwort auf die Bestellbestätigung.',
      aspetta: 'Einen Moment: Das Foto wird noch hochgeladen.',
      manca: 'Für dieses Produkt brauchen wir ein Foto: Lade es oben hoch.'
    }
  };

  function estensione(nome) {
    var i = (nome || '').lastIndexOf('.');
    return i < 0 ? '' : nome.slice(i + 1).toLowerCase();
  }

  class BuFotoUpload extends HTMLElement {
    connectedCallback() {
      if (this._pronto) return;
      this._pronto = true;
      this.t = TESTI[this.dataset.lingua] || TESTI.it;
      this.obbligatoria = this.dataset.obbligatoria === 'true';
      this.chiave = 'bu-foto:' + this.dataset.prodotto;
      this.inCorso = false;
      this.file = null;

      this.input = this.querySelector('.bu-foto__input');
      this.bottone = this.querySelector('.bu-foto__scegli');
      this.anteprima = this.querySelector('.bu-foto__anteprima');
      this.barra = this.querySelector('.bu-foto__barra');
      this.stato = this.querySelector('.bu-foto__stato');

      var radice = this.closest('product-info') || this.closest('section') || document;
      this.form = radice.querySelector('form[data-type="add-to-cart-form"]');
      if (!this.form) return;
      this.pulsante = this.form.querySelector('[type="submit"]');

      // la proprietà sta DENTRO il modulo: la vedono Dawn e qualunque app che lo legge
      this.campo = this.form.querySelector('input[name="' + NOME_PROPRIETA + '"]');
      if (!this.campo) {
        this.campo = document.createElement('input');
        this.campo.type = 'hidden';
        this.campo.name = NOME_PROPRIETA;
        this.campo.disabled = true;
        this.form.appendChild(this.campo);
      }

      this.bottone.addEventListener('click', this.onScegli.bind(this));
      this.input.addEventListener('change', this.onFile.bind(this));
      // in cattura: parte prima del gestore di Dawn e può fermare l'aggiunta al carrello
      this.form.addEventListener('submit', this.onInvio.bind(this), true);

      // dopo un'aggiunta riuscita il blocco si azzera: il prossimo pezzo può avere un'altra foto
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (evento) => {
          if (evento && evento.source === 'product-form') this.azzera();
        });
      }

      this.ripristina();
    }

    onScegli() {
      if (this.inCorso) return;
      if (this.file && this.stato.dataset.errore === 'rete') {
        this.carica(this.file);
        return;
      }
      this.input.value = '';
      this.input.click();
    }

    onFile() {
      var file = this.input.files && this.input.files[0];
      if (!file) return;
      if (ESTENSIONI.indexOf(estensione(file.name)) < 0 && !/^image\//.test(file.type)) {
        this.errore(this.t.tipo, 'tipo');
        return;
      }
      if (file.size > MAX_BYTE) {
        this.errore(this.t.troppo, 'troppo');
        return;
      }
      this.file = file;
      this.mostraAnteprima(file);
      this.carica(file);
    }

    mostraAnteprima(file) {
      var vedibile = /^image\/(jpeg|png|webp)$/.test(file.type);
      if (this._url) URL.revokeObjectURL(this._url);
      if (vedibile) {
        this._url = URL.createObjectURL(file);
        this.anteprima.src = this._url;
        this.anteprima.hidden = false;
      } else {
        this.anteprima.hidden = true;
      }
    }

    carica(file) {
      var self = this;
      var dati = new FormData();
      dati.append('file', file, file.name);
      dati.append('prodotto', this.dataset.prodotto);

      this.imposta('', null);
      this.inCorso = true;
      this.blocca(true);
      this.bottone.disabled = true;
      this.barra.hidden = false;
      this.barra.firstElementChild.style.width = '0%';
      this.scrivi(this.t.carica, '');

      var xhr = new XMLHttpRequest();
      xhr.open('POST', this.dataset.endpoint);
      xhr.timeout = 5 * 60 * 1000;
      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) self.barra.firstElementChild.style.width = Math.round((e.loaded / e.total) * 100) + '%';
      };
      xhr.onload = function () {
        var risposta = null;
        try { risposta = JSON.parse(xhr.responseText); } catch (e) { /* risposta non JSON */ }
        if (xhr.status === 200 && risposta && risposta.codice) {
          self.fine();
          self.imposta(risposta.codice + ' (' + file.name + ')', file.name);
          return;
        }
        self.fine();
        if (xhr.status === 413) return self.errore(self.t.troppo, 'troppo');
        if (xhr.status === 415) return self.errore(self.t.tipo, 'tipo');
        if (xhr.status === 429) return self.errore(self.t.tanti, 'rete');
        self.errore(self.t.rete, 'rete');
      };
      xhr.onerror = xhr.ontimeout = function () {
        self.fine();
        self.errore(self.t.rete, 'rete');
      };
      xhr.send(dati);
    }

    fine() {
      this.inCorso = false;
      this.blocca(false);
      this.bottone.disabled = false;
      this.barra.hidden = true;
    }

    imposta(valore, nome) {
      this.campo.value = valore;
      this.campo.disabled = !valore;
      try {
        if (valore) sessionStorage.setItem(this.chiave, JSON.stringify({ valore: valore, nome: nome }));
        else sessionStorage.removeItem(this.chiave);
      } catch (e) { /* sessionStorage non disponibile */ }
      if (valore) {
        this.scrivi(this.t.fatto + nome, 'ok');
        this.bottone.textContent = this.t.cambia;
      }
    }

    ripristina() {
      var salvato = null;
      try { salvato = JSON.parse(sessionStorage.getItem(this.chiave) || 'null'); } catch (e) { /* niente */ }
      if (salvato && salvato.valore) this.imposta(salvato.valore, salvato.nome);
    }

    azzera() {
      this.imposta('', null);
      this.file = null;
      this.anteprima.hidden = true;
      this.scrivi('', '');
      this.bottone.textContent = this.t.scegli;
    }

    errore(testo, tipo) {
      this.scrivi(testo, 'errore');
      this.stato.dataset.errore = tipo;
      this.bottone.textContent = tipo === 'rete' ? this.t.riprova : this.t.scegli;
      if (tipo !== 'rete') this.file = null;
    }

    scrivi(testo, classe) {
      this.stato.textContent = testo;
      this.stato.className = 'bu-foto__stato' + (classe ? ' bu-foto__stato--' + classe : '');
      delete this.stato.dataset.errore;
    }

    blocca(si) {
      if (!this.pulsante) return;
      if (si) {
        this._eraBloccato = this.pulsante.getAttribute('aria-disabled');
        this.pulsante.setAttribute('aria-disabled', 'true');
      } else if (this._eraBloccato === null || this._eraBloccato === undefined) {
        this.pulsante.removeAttribute('aria-disabled');
      }
    }

    onInvio(evento) {
      if (this.inCorso) {
        evento.preventDefault();
        evento.stopImmediatePropagation();
        this.scrivi(this.t.aspetta, 'errore');
        return;
      }
      if (this.obbligatoria && !this.campo.value) {
        evento.preventDefault();
        evento.stopImmediatePropagation();
        this.scrivi(this.t.manca, 'errore');
        this.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  }

  customElements.define('bu-foto-upload', BuFotoUpload);
})();
/* FZ - End - Caricamento foto clienti sul VPS (upload_foto) */
